import Index from 'src/pages/Causes/Index.vue'
import Create from 'src/pages/Causes/Create.vue'
import Edit from 'src/pages/Causes/Edit.vue'

const auth = { requiresAuth: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/causes',
    name: 'Gründe',
    component: Index,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/causes/create',
    name: 'Grund Erstellen',
    component: Create,
    meta: { ...auth, ...notUser }
  },
  {
    path: '/causes/:id/edit',
    name: 'Grund Bearbeiten',
    component: Edit,
    meta: { ...auth, ...notUser }
  }
]
